import { Component, Input, Output, EventEmitter } from '@angular/core'
import { environment } from 'src/env/environment'

@Component({
  selector: 'maglive-login-alert',
  templateUrl: './login-alert.component.html',
  styleUrls: ['./login-alert.component.scss'],
})
export class LoginAlertComponent {
  @Input() isShowLoginAlert: boolean
  @Input() isScreenRotated: boolean
  @Input() actionText: string
  @Output() closeAlertEvent = new EventEmitter<string | void>()

  loginCallbackURL =
    environment.baseURL.mag2mypage + 'Welcome.do?ref=' + window.location.href

  cancelBtn() {
    this.closeAlertEvent.emit()
  }
}
